import type { RouteRecordRaw } from 'vue-router';

export const salonReportsRoutes: RouteRecordRaw[] = [
  {
    path: 'salon/revenue-by-stylist',
    name: 'salon-revenue-by-stylist',
    component: () => import('./pages/StylistRevenuePage.vue'),
    meta: { title: 'Revenue by stylist', requiresAuth: true, permission: 'is-admin' },
  },
];
